import type { ReactNode } from 'react'

/**
 * The facts of one thing — a Parcel, a Bag, a Shift — as one grid of «label: value»
 * under a card's heading: no frame around each, every cell the same width, filled in
 * order with no gaps (put the facts in the order of what matters most). Four
 * columns on a desktop, two on a narrow screen.
 */
export function Facts({ children, testId }: { children: ReactNode; testId?: string }) {
	return (
		<dl className='grid grid-cols-2 gap-x-8 gap-y-4 lg:grid-cols-4' data-testid={testId}>
			{children}
		</dl>
	)
}

/** One fact of `Facts`: its label small and muted, its value under it. */
export function Fact({ label, children, testId }: { label: ReactNode; children: ReactNode; testId?: string }) {
	return (
		<div className='flex min-w-0 flex-col gap-1' data-testid={testId}>
			<dt className='text-xs text-muted-foreground'>{label}</dt>
			<dd className='text-sm break-words'>{children}</dd>
		</div>
	)
}
